import React from 'react';
import SubHeader from '../../../fragments/SubHeader';
import BreadCrumbContainer from '../../../fragments/BreadCrumbContainer';
import BreadCrumb from '../../../fragments/BreadCrumb';
import { useNavigate } from 'react-router-dom';

const SubHeaderMisVentas = () => {
  const navigate = useNavigate();
  return (
    <SubHeader>
      <BreadCrumbContainer>
        <BreadCrumb route={'Inicio /'} onClick={() => navigate(`/home`)} />
        <BreadCrumb route={'Mis pedidos'} active />
      </BreadCrumbContainer>
    </SubHeader>
  );
};

export default SubHeaderMisVentas;
